export default __webpack_public_path__ + "static/media/toaster.666ee5c2.svg";